export default "__VITE_ASSET__57ef3a46__"